import { DriverGroupDto } from '@cargovibe/shared-types';
import { Badge } from '@/shared/ui/badge';

interface Props {
  groups: DriverGroupDto[];
}

export function DriverGroupBadges({ groups }: Readonly<Props>): React.JSX.Element {
  if (groups.length === 0) {
    return <span className="text-muted-foreground">-</span>;
  }

  return (
    <div className="flex flex-wrap gap-1.5">
      {groups.map((group: DriverGroupDto) => (
        <Badge
          key={group.id}
          className="border-transparent bg-violet-100 text-violet-800 hover:bg-violet-100 whitespace-nowrap"
        >
          {group.name}
        </Badge>
      ))}
    </div>
  );
}
